import type { Newsletter } from "~types/types";

export async function fetchNewsletterFromApi(slug: string) {
  const newsletterResponse = await fetch(`/lineup-next/api/newsletter/${slug}`);

  if (!newsletterResponse.ok) {
    throw new Error(
      `Error when fetching from api/newsletter: ${await newsletterResponse.text()}`
    );
  }

  return (await newsletterResponse.json()) as Newsletter;
}
